import React from 'react';
import { Tooltip } from '@mui/material';
import { formatCurrency, formatPercentage } from 'utils';
import { grey } from '@mui/material/colors';
import { Column } from 'components/shared/TableListing/types';
import { Info } from '@mui/icons-material';
import { NetFinanceAmountListingEntity } from '../../../types';

export const NFAListingColumns: Column<NetFinanceAmountListingEntity>[] = [
  {
    header: 'Hard Cost',
    renderKey: 'hardCost',
    formatter: value => formatCurrency(value, true),
    endIcon: (
      <Tooltip placement="top" arrow title="Sum of all equipment and attachment base prices. Auto-calculated">
        <Info color="primary" fontSize="small" />
      </Tooltip>
    ),
    headerStyles: {
      backgroundColor: grey[200],
    },
    cellStyles: {
      minHeight: 'auto',
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
  },
  {
    header: 'Fees',
    renderKey: 'fees',
    formatter: value => formatCurrency(value, true),
    endIcon: (
      <Tooltip
        arrow
        placement="top"
        title="Sum of all fees included in the invoice, including those related to equipment, attachments, or added manually"
      >
        <Info color="primary" fontSize="small" />
      </Tooltip>
    ),
    headerStyles: {
      backgroundColor: grey[200],
    },
    cellStyles: {
      minHeight: 'auto',
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
  },
  {
    header: 'Taxes',
    renderKey: 'taxes',
    formatter: value => formatCurrency(value, true),
    endIcon: (
      <Tooltip placement="top" arrow title="Sum of all applicable taxes included in invoice">
        <Info color="primary" fontSize="small" />
      </Tooltip>
    ),
    headerStyles: {
      backgroundColor: grey[200],
    },
    cellStyles: {
      minHeight: 'auto',
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
  },
  {
    header: 'Soft Cost %',
    renderKey: 'softCost',
    formatter: value => (value == null || !isFinite(value) ? '—' : formatPercentage(value)),
    endIcon: (
      <Tooltip
        arrow
        placement="top"
        title="Percentage of Fees and Taxes relative to Hard Cost. Calculated as (Fees + Taxes) ÷ Hard Cost."
      >
        <Info color="primary" fontSize="small" />
      </Tooltip>
    ),
    headerStyles: {
      backgroundColor: grey[200],
    },
    cellStyles: {
      minHeight: 'auto',
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
  },
  {
    header: 'Net Finance Amount ',
    renderKey: 'netFinanceAmount',
    formatter: value => formatCurrency(value, true),
    endIcon: (
      <Tooltip
        arrow
        placement="top"
        title="Total amount to be financed, including hard cost, fees, and taxes, minus trade-in and deposit"
      >
        <Info color="primary" fontSize="small" />
      </Tooltip>
    ),
    headerStyles: {
      backgroundColor: grey[200],
    },
    cellStyles: {
      minHeight: 'auto',
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
  },
];
